(function () {
    'use strict';

    angular.module('app.controllers')
        .controller('StreamingReportCtrl', StreamingReportCtrl)
    ;

    /* @ngInject */
    function StreamingReportCtrl(DataFactory) {

        var vm = this;

        vm.filter = [
            {
                label: 'December 2019',
                value: 'December 2019'
            },
            {
                label: 'November 2019',
                value: 'November 2019'
            },
            {
                label: 'October 2019',
                value: 'October 2019'
            },
            {
                label: 'September 2019',
                value: 'September 2019'
            },
            {
                label: 'August 2019',
                value: 'August 2019'
            },
            {
                label: 'July 2019',
                value: 'July 2019'
            },
            {
                label: 'June 2019',
                value: 'June 2019'
            },
            {
                label: 'May 2019',
                value: 'May 2019'
            },
            {
                label: 'April 2019',
                value: 'April 2019'
            },
            {
                label: 'March 2019',
                value: 'March 2019'
            },
            {
                label: 'February 2019',
                value: 'February 2019'
            },
            {
                label: 'January 2019',
                value: 'January 2019'
            },
            {
                label: 'December 2018',
                value: 'December 2018'
            },
            {
                label: 'November 2018',
                value: 'November 2018'
            },
            {
                label: 'October 2018',
                value: 'October 2018'
            },
            {
                label: 'September 2018',
                value: 'September 2018'
            },
            {
                label: 'August 2018',
                value: 'August 2018'
            },
            {
                label: 'July 2018',
                value: 'July 2018'
            },
            {
                label: 'June 2018',
                value: 'June 2018'
            },
            {
                label: 'May 2018',
                value: 'May 2018'
            },
        ]
        vm.selected = vm.filter[0];

        vm.dataTypes = [
            {
                label: 'DCR Monthly Total',
                value: 'DCR Monthly Total'
            },
            {
                label: 'DCR Monthly Tagged',
                value: 'DCR Monthly Tagged'
            },
        ];
        vm.visibleType = vm.dataTypes[0];

        DataFactory.getTableData('streaming-report').then(function (allData) {

            var streamingReportPanel = {};
            var streamingReportAd = {};

            angular.forEach(allData.rows, function (row) {
                var month = row.values[0];
                var type = row.values[1];

                if (streamingReportPanel[month] === undefined) {
                    streamingReportPanel[month] = {
                        columns: allData.columns.slice(2),
                        rows: []
                    };
                }

                if (streamingReportAd[month] === undefined) {
                    streamingReportAd[month] = {
                        columns: allData.columns.slice(2),
                        rows: []
                    };
                }

                var brandData = {
                    values: []
                };

                // Ignore month and type
                for (var i = 2; i < row.values.length; i++) {
                    brandData.values.push(row.values[i]);
                }

                // 'Computer Panel' is name of CSV column
                type === 'Computer Panel' ? streamingReportPanel[month].rows.push(brandData) : streamingReportAd[month].rows.push(brandData)
            });

            vm.streamingReportPanel = streamingReportPanel;
            vm.streamingReportAd = streamingReportAd;
        });
    }

})();
